module.exports = __webpack_public_path__ + "fa1daa0110d59c6083865c7c37071116.fbx";